export default function NotFound() {
    return (
        <div style={{ display: 'flex',height:'80vh' }}>
            <h1 style={{ margin: 'auto' }}>
                404 page not found
            </h1>
        </div>
    )
}